import { Rect, type Node } from "@revideo/2d";
import type { Clip } from "@hudhud/core";
import { HEIGHT, WIDTH } from "@hudhud/reel/math";

/** The thin bar that fills across the speech. Mirrors ProgressBar in the Remotion reel. */
export function progressLayer(o: { clip: Clip; frame: () => number; from: number; totalFrames: number }): Node {
  const { barPos, barColor, barHeight } = o.clip.brand;
  const y = (barPos === "top" ? barHeight / 2 : HEIGHT - barHeight / 2) - HEIGHT / 2;
  const p = () => Math.min(1, (o.frame() - o.from) / Math.max(1, o.totalFrames));
  return new Rect({
    width: WIDTH, height: barHeight, y, fill: "rgba(255,255,255,0.18)",
    children: [new Rect({ x: -WIDTH / 2, offset: [-1, 0], width: () => WIDTH * p(), height: barHeight, fill: barColor })],
  });
}
